import { all } from 'redux-saga/effects';
import companyInfoServiceWorker from './authorisedSaga';
import getCompanyInfoServiceWorker from './authorisedSaga';

export default function* rootSaga(action) {
	yield all([companyInfoServiceWorker(action)]);
	yield all([getCompanyInfoServiceWorker(action)]);
}
